function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* globals KA */

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");
var $ = require("jquery");

var HighlightableContent = require("../components/highlighting/highlightable-content.jsx");
var Renderer = require("../renderer.jsx");
var PassageMarkdown = require("./passage/passage-markdown.jsx");

var _require2 = require("../gorgon/proptypes.js"),
    linterContextDefault = _require2.linterContextDefault;

var babelPluginFlowReactPropTypes_proptype_ChangeableProps = require("../mixins/changeable.jsx").babelPluginFlowReactPropTypes_proptype_ChangeableProps || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_SerializedHighlightSet = require("../components/highlighting/types.js").babelPluginFlowReactPropTypes_proptype_SerializedHighlightSet || require("react").PropTypes.any;

// A fake paragraph to measure the line height of the passage. In CSS we always
// set the line height to 22 pixels, but when using the browser zoom feature,
// the line height often ends up being a fractional number of pixels close to
// 22 pixels.
var LineHeightMeasurer = function (_React$Component) {
    _inherits(LineHeightMeasurer, _React$Component);

    function LineHeightMeasurer() {
        _classCallCheck(this, LineHeightMeasurer);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    LineHeightMeasurer.prototype.measureLineHeight = function measureLineHeight() {
        if (typeof this._cachedLineHeight !== "number") {
            this.forceMeasureLineHeight();
        }

        return this._cachedLineHeight;
    };

    LineHeightMeasurer.prototype.forceMeasureLineHeight = function forceMeasureLineHeight() {
        // Add some text which magically fills an entire line.
        this.$body.text(" \x80");

        // Now, the line height is the difference between the top of the
        // second line and the top of the first line.
        this._cachedLineHeight = this.$end.offset().top - this.$body.offset().top;

        // Clear out the first line so it doesn't overlap the passage.
        this.$body.text("");
    };

    LineHeightMeasurer.prototype.render = function render() {
        var _this2 = this;

        return React.createElement(
            "div",
            { className: css(styles.measurer) },
            React.createElement(
                "div",
                null,
                React.createElement("div", { ref: function ref(e) {
                        return _this2.$body = $(e);
                    }, className: "paragraph" }),
                React.createElement("div", { ref: function ref(e) {
                        return _this2.$end = $(e);
                    } })
            )
        );
    };

    return LineHeightMeasurer;
}(React.Component);

var styles = StyleSheet.create({
    measurer: {
        position: "absolute",
        width: "100%",
        top: 0,
        left: 0
    }
});

// State kept track of by the PassageMarkdown parser.


// Information about a passage reference, used in inter-widgets.

var Passage = function (_React$Component2) {
    _inherits(Passage, _React$Component2);

    function Passage() {
        var _temp, _this3, _ret;

        _classCallCheck(this, Passage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this3), _this3.state = {
            nLines: null,
            startLineNumbersAfter: 0,
            stylesAreApplied: false
        }, _this3._handleSerializedHighlightsUpdate = function (serializedHighlights) {
            _this3.props.onChange({ highlights: serializedHighlights });
        }, _temp), _possibleConstructorReturn(_this3, _ret);
    }

    Passage.prototype.componentDidMount = function componentDidMount() {
        var _this4 = this;

        this._updateState();

        this._onResize = _.throttle(function () {
            // If we're rendering JIPT text, we won't have line numbers or a
            // line height measurer, so skip handling this resize.
            if (_this4.shouldRenderJipt()) {
                return;
            }

            // Remeasure the line height on resize, because the only line
            // height changes we expect are subpixel changes when the user
            // zooms in/out, and the only way to listen for zoom events is to
            // listen for resize events.
            _this4._lineHeightMeasurer.forceMeasureLineHeight();
            _this4._updateState();
        }, 500);
        window.addEventListener("resize", this._onResize);

        // Wait for Aphrodite styles (which are guaranteed to apply after one
        // tick), then set state.
        //
        // This flag is used to set the `enabled` prop of the
        // `HighlightableContent` component. That way, we only show highlights
        // once styles are ready, and they're measured with the correct
        // position.
        //
        // HACK(mdr): It's not really the Passage's Aphrodite styles that are
        //     causing bad measures, but more so the Khan Academy Test Prep
        //     app's Aphrodite styles. We would ideally instead offer the
        //     embedding application an API to signal that the app's layout has
        //     changed in a way that affects the Renderer... but, for now, just
        //     hardcode this hack into here.
        window.setTimeout(function () {
            _this4.setState({ stylesAreApplied: true });
        }, 0);
    };

    Passage.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return !_.isEqual(this.props, nextProps) || !_.isEqual(this.state, nextState);
    };

    Passage.prototype.componentDidUpdate = function componentDidUpdate() {
        this._updateState();
    };

    Passage.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("resize", this._onResize);
    };

    /**
     * Line numbering
     *
     * These functions support passage line numbering, which is non-trivial
     * because we manually measure lines to support resizing as well as
     * continuing line numbers from previous passages.
     */

    Passage.prototype._updateState = function _updateState() {
        // If we're rendering JIPT text, we're not rendering line numbers so we
        // don't need to update this state.
        if (this.shouldRenderJipt()) {
            return;
        }

        this.setState({
            nLines: this._measureLines(),
            startLineNumbersAfter: this._getInitialLineNumber()
        });
    };

    Passage.prototype._measureLines = function _measureLines() {
        var $renderer = $(ReactDOM.findDOMNode(this.refs.content));
        var contentsHeight = $renderer.height();
        var lineHeight = this._getLineHeight();
        var nLines = Math.round(contentsHeight / lineHeight);
        return nLines;
    };

    Passage.prototype._getInitialLineNumber = function _getInitialLineNumber() {
        var _this5 = this;

        var isPassageBeforeThisPassage = true;
        var passagesBeforeUs = this.props.findWidgets(function (id, widgetInfo) {
            if (widgetInfo.type !== "passage") {
                return false;
            }
            if (id === _this5.props.widgetId) {
                isPassageBeforeThisPassage = false;
            }
            return isPassageBeforeThisPassage;
        });

        return passagesBeforeUs.map(function (passageWidget) {
            return passageWidget.getLineCount();
        }).reduce(function (a, b) {
            return a + b;
        }, 0);
    };

    Passage.prototype._getLineHeight = function _getLineHeight() {
        return this._lineHeightMeasurer.measureLineHeight();
    };

    Passage.prototype.getLineCount = function getLineCount() {
        if (this.state.nLines != null) {
            return this.state.nLines;
        } else {
            return this._measureLines();
        }
    };

    /**
     * Passage refs
     *
     * These are functions to support the passage refs inter-widgets feature
     * where other widgets can fetch the line numbers of a reference inside of
     * a passage.
     */

    Passage.prototype._getStartRefLineNumber = function _getStartRefLineNumber(referenceNumber) {
        var refRef = PassageMarkdown.START_REF_PREFIX + referenceNumber;
        var ref = this.refs[refRef];
        if (!ref) {
            return null;
        }

        var $ref = $(ReactDOM.findDOMNode(ref));
        // We really care about the first text after the ref, not the
        // ref element itself:
        var $refText = $ref.next();
        if ($refText.length === 0) {
            // But if there are no elements after the ref, just
            // use the ref itself.
            $refText = $ref;
        }
        var vPos = $refText.offset().top;

        return this.state.startLineNumbersAfter + 1 + this._convertPosToLineNumber(vPos);
    };

    Passage.prototype._getEndRefLineNumber = function _getEndRefLineNumber(referenceNumber) {
        var refRef = PassageMarkdown.END_REF_PREFIX + referenceNumber;
        var ref = this.refs[refRef];
        if (!ref) {
            return null;
        }

        var $ref = $(ReactDOM.findDOMNode(ref));
        // We really care about the last text before the ref, not the
        // ref element itself:
        var $refText = $ref.prev();
        if ($refText.length === 0) {
            // But if there are no elements before the ref, just
            // use the ref itself.
            $refText = $ref;
        }
        var height = $refText.height();
        var vPos = $refText.offset().top;

        var line = this._convertPosToLineNumber(vPos + height);
        if (height === 0) {
            // If the element before the end ref span was the start
            // ref span, it might have 0 height. This is obviously not
            // the intended use case, but we should handle it gracefully.
            // If this is the case, then the "bottom" of our element is
            // actually the top of the line we're on, so we need to add
            // one to the line number.
            line += 1;
        }

        return this.state.startLineNumbersAfter + line;
    };

    Passage.prototype._convertPosToLineNumber = function _convertPosToLineNumber(absoluteVPos) {
        var $content = $(ReactDOM.findDOMNode(this.refs.content));
        var relativeVPos = absoluteVPos - $content.offset().top;
        var lineHeight = this._getLineHeight();

        var line = Math.round(relativeVPos / lineHeight);
        return line;
    };

    Passage.prototype._getRefContent = function _getRefContent(referenceNumber) {
        var refRef = PassageMarkdown.START_REF_PREFIX + referenceNumber;
        var ref = this.refs[refRef];
        if (!ref) {
            return null;
        }
        return ref.getRefContent();
    };

    Passage.prototype.getReference = function getReference(referenceNumber) {
        var refStartLine = this._getStartRefLineNumber(referenceNumber);
        var refEndLine = this._getEndRefLineNumber(referenceNumber);
        if (refStartLine == null || refEndLine == null) {
            return null;
        }
        var refContent = this._getRefContent(referenceNumber);

        return {
            startLine: refStartLine,
            endLine: refEndLine,
            content: refContent
        };
    };

    /**
     * Misc functions
     *
     * These are misc widget functions used for the widget API
     */

    Passage.prototype.getUserInput = function getUserInput() {
        return null;
    };

    Passage.prototype.simpleValidate = function simpleValidate(rubric) {
        return Passage.validate(this.getUserInput(), rubric);
    };

    /* eslint-disable react/sort-comp */


    Passage.validate = function validate(state, rubric) {
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    };
    /* eslint-enable react/sort-comp */

    /**
     * Rendering
     *
     * Functions to render the passage widget.
     */

    Passage.prototype._renderInstructions = function _renderInstructions(parseState) {
        var firstQuestionNumber = parseState.firstQuestionRef;
        var firstSentenceRef = parseState.firstSentenceRef;

        var instructions = "";
        if (firstQuestionNumber) {
            instructions += i18n._("The symbol %(questionSymbol)s indicates that question " + "%(questionNumber)s references this portion of the " + "passage.", {
                questionSymbol: "[[" + firstQuestionNumber + "]]",
                questionNumber: firstQuestionNumber
            });
        }
        if (firstSentenceRef) {
            instructions += i18n._(" The symbol %(sentenceSymbol)s indicates that the " + "following sentence is referenced in a question.", {
                sentenceSymbol: "[" + firstSentenceRef + "]"
            });
        }
        var parsedInstructions = PassageMarkdown.parse(instructions);
        return React.createElement(
            "div",
            { className: "perseus-widget-passage-instructions" },
            PassageMarkdown.output(parsedInstructions)
        );
    };

    Passage.prototype.shouldRenderJipt = function shouldRenderJipt() {
        // Mostly copied from `renderer.jsx`. If we're doing JIPT, we want to
        // render our content differently.
        return (
            // $FlowFixMe KA is a global
            typeof KA !== "undefined" && KA.language === "en-pt" && this.props.passageText.indexOf("crwdns") !== -1
        );
    };

    Passage.prototype._renderContent = function _renderContent(parsed) {
        var _this6 = this;

        // Wait until Aphrodite styles are applied before enabling highlights,
        // so that we measure the correct positions.
        var enabled = this.state.stylesAreApplied;

        // Highlights are read-only in review mode.
        var editable = !this.props.reviewModeRubric;

        return React.createElement(
            HighlightableContent,
            {
                editable: editable,
                enabled: enabled,
                onSerializedHighlightsUpdate: this._handleSerializedHighlightsUpdate,
                serializedHighlights: this.props.highlights
            },
            React.createElement(
                "div",
                { ref: "content" },
                React.createElement(LineHeightMeasurer, {
                    ref: function ref(e) {
                        return _this6._lineHeightMeasurer = e;
                    }
                }),
                PassageMarkdown.output(parsed)
            )
        );
    };

    Passage.prototype._hasFootnotes = function _hasFootnotes() {
        var rawContent = this.props.footnotes;
        var isEmpty = /^\s*$/.test(rawContent);
        return !isEmpty;
    };

    Passage.prototype._renderFootnotes = function _renderFootnotes() {
        var rawContent = this.props.footnotes;
        var parsed = PassageMarkdown.parse(rawContent);
        return PassageMarkdown.output(parsed);
    };

    Passage.prototype.render = function render() {
        var _this7 = this;

        var lineNumbers = void 0;
        var nLines = this.state.nLines;
        if (this.props.showLineNumbers && nLines) {
            // lineN is the line number in the current passage;
            // the displayed line number is
            // lineN + this.state.startLineNumbersAfter, where
            // startLineNumbersAfter is the sum of all line numbers
            // in earlier passages.
            lineNumbers = _.range(1, nLines + 1).map(function (lineN) {
                if (lineN === 4 && nLines > 4) {
                    return React.createElement(
                        "span",
                        { key: "line-marker", className: "line-marker" },
                        "Line"
                    );
                } else {
                    return React.createElement(
                        "span",
                        { key: lineN },
                        lineN + _this7.state.startLineNumbersAfter
                    );
                }
            });
        }

        var parseState = {
            firstSentenceRef: null,
            firstQuestionRef: null
        };
        var parsedContent = PassageMarkdown.parse(this.props.passageText, parseState);

        // Check if the title has any non-empty text in it.
        var hasTitle = /\S/.test(this.props.passageTitle);

        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                { className: "perseus-widget-passage-container" },
                this._renderInstructions(parseState),
                React.createElement(
                    "div",
                    { className: "perseus-widget-passage" },
                    hasTitle && React.createElement(
                        "h3",
                        { className: "passage-title" },
                        React.createElement(Renderer, {
                            content: this.props.passageTitle,
                            linterContext: this.props.linterContext
                        })
                    ),
                    lineNumbers && React.createElement(
                        "div",
                        { className: "line-numbers", "aria-hidden": true },
                        lineNumbers
                    ),
                    !hasTitle && React.createElement(
                        "h3",
                        { className: "perseus-sr-only" },
                        i18n._("Beginning of reading passage.")
                    ),
                    React.createElement(
                        "div",
                        { className: "passage-text" },
                        this.shouldRenderJipt() ? // If we're in JIPT mode, just pass off our
                        // content to a <Renderer /> which knows how
                        // to handle rendering JIPT text.
                        React.createElement(Renderer, { content: this.props.passageText }) : this._renderContent(parsedContent)
                    ),
                    this._hasFootnotes() && [React.createElement(
                        "h4",
                        {
                            key: "footnote-start",
                            className: "perseus-sr-only"
                        },
                        i18n._("Beginning of reading passage footnotes.")
                    ), React.createElement(
                        "div",
                        { key: "footnotes", className: "footnotes" },
                        this._renderFootnotes()
                    )],
                    React.createElement(
                        "div",
                        { className: "perseus-sr-only" },
                        i18n._("End of reading passage.")
                    )
                )
            )
        );
    };

    return Passage;
}(React.Component);

Passage.defaultProps = {
    passageTitle: "",
    passageText: "",
    footnotes: "",
    showLineNumbers: true,
    highlights: {},
    linterContext: linterContextDefault
};


module.exports = {
    name: "passage",
    displayName: "Passage (SAT only)",
    widget: Passage,
    transform: function transform(editorProps) {
        return _.pick(editorProps, "passageTitle", "passageText", "footnotes", "showLineNumbers");
    },
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/passage.jsx
 ** module id = 134
 ** module chunks = 0 1
 **/